export enum EmploymentSector {
  Agriculture = 1,
  Mining = 2,
  Utilities = 3,
  Construction = 4,
  Manufacturing = 5,
  WholesaleTrade = 6,
  RetailTrade = 7,
  Transportation = 8,
  Information = 9,
  Finance = 10,
  RealEstate = 11,
  Professional = 12,
  Government = 13,
  Education = 14,
  Healthcare = 15,
  ArtsEntertainment = 16,
  Accommodation = 17,
  OtherServices = 18,
  NotApplicable = 0,
}
